import { useCallback, useEffect, useState } from 'react';
import { useSupabaseAuth } from '@/components/auth';
import { websiteUrls } from '@/lib/site-urls';


export function useBalance() {
  const { token } = useSupabaseAuth();
  const [remainingBalance, setRemainingBalance] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(websiteUrls.billing('balance'), {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = (await res.json()) as { remainingBalanceUsd: number };
      setRemainingBalance(data.remainingBalanceUsd);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load balance');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { remainingBalance, loading, error, refresh };
}
